import { AppBar, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const drawerWidth = 240;

export const Root = styled("div")(({ theme }) => ({
  display: "flex",
  "& .MuiTextField-root": {
    margin: theme.spacing(1),
    width: 200,
  },
}));

export const AppBarStyled = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const ToolbarIcon = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: "0px 8px",
  ...theme.mixins.toolbar,
}));

export const PanelContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "width",
})(({ theme, open, width }) => ({
  width: open ? width : theme.spacing(7),
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflow: "hidden",
  display: "flex",
  flexShrink: 0,
  flexDirection: "column",
  borderRight: open ? "1px solid #ddd" : "none",
  backgroundColor: theme.palette.background.paper,
  position: "relative",
}));



// export const styles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     "& .MuiTextField-root": {
//       margin: theme.spacing(1),
//       width: 200,
//     },
//   },
//   toolbar: {
//     paddingRight: 24,
//   },
//   toolbarIcon: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     padding: "0 8px",
//     ...theme.mixins.toolbar,
//   },
//   appBar: {
//     zIndex: theme.zIndex.drawer + 1,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//   },
//   appBarShift: {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   menuButton: {
//     marginLeft: 12,
//     marginRight: 36,
//   },
//   menuButtonHidden: {
//     display: "none",
//   },
//   title: {
//     flexGrow: 1,
//   },
//   drawerPaper: {
//     position: "relative",
//     whiteSpace: "nowrap",
//     width: drawerWidth,
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   drawerPaperClose: {
//     overflowX: "hidden",
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     width: theme.spacing(7),
//     [theme.breakpoints.up("sm")]: {
//       width: theme.spacing(9),
//     },
//   },
//   dragger: {
//     width: "5px",
//     cursor: "col-resize",
//     padding: "4px 0 0",
//     borderTop: "1px solid #ddd",
//     position: "absolute",
//     top: 0,
//     right: 0,
//     bottom: 0,
//     zIndex: 100,
//     backgroundColor: "#f4f7f9",
//   },
//   appBarSpacer: theme.mixins.toolbar,
//   content: {
//     flexGrow: 1,
//     padding: theme.spacing(3),
//     height: "100vh",
//     overflow: "auto",
//   },
//   chartContainer: {
//     marginLeft: -22,
//   },
//   tableContainer: {
//     height: 320,
//   },
//   h5: {
//     marginBottom: theme.spacing(2),
//   },
//   taskTree: {
//     padding: "3%",
//   },
//   hidden: {
//     display: "none",
//   },
//   taskPanelDistributionPicker: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     margin: "0px -8px",
//   },
//   taskPanelDistributionPickerItem: {
//     margin: "0px 8px",
//   },
//   periodSelectContainer: {
//     width: "100%",
//   },
//   taskTableRow: {
//     textAlign: "center",
//   },
// }));


// export const styles = (theme) => ({
//   root: {
//     display: "flex",
//     "& .MuiTextField-root": {
//       margin: theme.spacing(1),
//       width: 200,
//     },
//   },
//   toolbar: {
//     paddingRight: 24, // keep right padding when drawer closed
//   },
//   toolbarIcon: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     padding: "0 8px",
//     ...theme.mixins.toolbar,
//   },
//   appBar: {
//     zIndex: theme.zIndex.drawer + 1,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//   },
//   appBarShift: {
//     marginLeft: 240,
//     width: `calc(100% - 240px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   menuButton: {
//     marginLeft: 12,
//     marginRight: 36,
//   },
//   menuButtonHidden: {
//     display: "none",
//   },
//   title: {
//     flexGrow: 1,
//   },
//   drawerPaper: {
//     position: "relative",
//     whiteSpace: "nowrap",
//     width: 240,
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   dragger: {
//     width: "5px",
//     cursor: "col-resize",
//     padding: "4px 0 0",
//     borderTop: "1px solid #ddd",
//     position: "absolute",
//     top: 0,
//     right: 0,
//     bottom: 0,
//     zIndex: "100",
//     backgroundColor: "#f4f7f9",
//   },
//   drawerPaperClose: {
//     overflowX: "hidden",
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     width: theme.spacing(7),
//     [theme.breakpoints.up("sm")]: {
//       width: theme.spacing(9),
//     },
//   },
//   appBarSpacer: theme.mixins.toolbar,
//   content: {
//     flexGrow: 1,
//     padding: theme.spacing(3),
//     height: "100vh",
//     overflow: "auto",
//   },
//   chartContainer: {
//     marginLeft: -22,
//   },
//   tableContainer: {
//     height: 320,
//   },
//   h5: {
//     marginBottom: theme.spacing(2),
//   },
//   taskTree: {
//     padding: "3%",
//   },
//   hidden: {
//     display: "none",
//   },
//   taskPanelDistributionPicker: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     margin: "0px -8px",
//   },
//   taskPanelDistributionPickerItem: {
//     margin: "0px 8px",
//   },
//   periodSelectContainer: {
//     width: "100%",
//   },
//   taskTableRow: {
//     textAlign: "center",
//   },
// });

export const styles = ((theme) => { })

export const ColorPalette = [
  "#2DABE2",
  "#b3de69",
  "#bebada",
  "#fb8072",
  "#80b1d3",
  "#fdb462",
  "#8F971E",
  "#fccde5",
  "#d9d9d9",
  "#bc80bd",
  "#ccebc5",
  "#ffed6f",
];
